module.exports = __webpack_public_path__ + "static/media/22.b8cb29ff.jpg";